
export const FIDE_EXPANSION = "FIDE";
export const CRUSADER_EXPANSION = "Crusaders"